import PropTypes from "prop-types";

// Soft UI Dashboard React base styles
import colors from "assets/theme/base/colors";

function Arrow({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>arrow-down</title>
      <g fill={colors[color] ? colors[color].main : colors.dark.main}>
        <path d="M12 22L2 12h8V2h4v10h8L12 22z" />
      </g>
    </svg>
  );
}

// Setting default values for the props of ArrowDown
Arrow.defaultProps = {
  color: "dark",
  size: "16px",
};

// Typechecking props for the ArrowDown
Arrow.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "light",
    "white",
  ]),
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default Arrow;
